import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const categoryList = (params = '') => Http.get(`/admin/venture-categories${serialize(params)}`)
export const categoryCreate = (params = '') => Http.post('/admin/venture-categories', params)
export const categoryByID = (params = '') => Http.get(`/admin/venture-categories/${params}`)
export const categoryUpdate = (params = '') => Http.put(`/admin/venture-categories/${params.id}`, params)
export const categoryDestroy = (params = '') => Http.delete(`/admin/venture-categories/${params.id}`)
